import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'payout-statements-dialog-content',
  templateUrl: './payout-statements-dialog-content.component.html',
  styleUrls: ['./payout-statements-dialog-content.component.scss']
})
export class PayoutStatementsDialogContentComponent extends AbstractDialogContent {

  public className = 'PayoutStatementsDialogContentComponent';

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  close() {
    this.activeModal.close();
  }
}
